// lenis-scroll.js
import Lenis from 'lenis'
import AbstractComponent from "./abstract-component"

export default class LCS extends AbstractComponent {
    constructor(el) {
        super(el)
        this._rafId = null
        this.init()
    }

    init() {
        this.createScroll()
    }

    createScroll() {
        this.lenis = new Lenis({
            duration: 1.1,
            easing: (t) => 1 - Math.pow(1 - t, 3),
            smoothWheel: true,
            smoothTouch: false,
            gestureOrientation: 'vertical',
            wheelMultiplier: 1.0,
        })

        const raf = (time) => {
            this.lenis.raf(time)
            this._rafId = requestAnimationFrame(raf)
        }
        this._rafId = requestAnimationFrame(raf)
    }

    disable() { this.lenis?.stop() }
    enable() { this.lenis?.start() }

    scrollTo(target, offset = 0) {

        this.lenis?.scrollTo(target, {
            offset,
            duration: 1,
            //easing: (t) => 1 - Math.pow(1 - t, 3),
            immediate: false,
            lock: false,
            force: false,
        })
    }

    update() { /* plus rien à faire ici */ }

    destroy() {
        if (this._rafId) cancelAnimationFrame(this._rafId)
        this.lenis?.destroy()
        this.lenis = null
    }
}
